import React, { useEffect, useState } from 'react';
import {
    Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { callApi } from 'src/core/callApi';
import CloseIcon from '@mui/icons-material/Close';
import GoogleMapReact from 'google-map-react';
import { getPolygonPaths, mapOptions } from 'src/utils/functions';
import { Coordinates } from 'src/interfaces/idashboard';
import { OnboardingModal } from 'src/App/Modals';
import { getTokenThunk } from 'src/store/Auth/actions';
import { getTailoredRegionMarkers } from 'src/store/Dashboard/actions';

const LoaderScreen = () => {
    return (
      <Backdrop open={true} sx={{ zIndex: 5 }}>
        <CircularProgress />
      </Backdrop>
    );
  };

const IndividualMarketView = ({
  region,
  currentIndex,
  setUpdatedCsv,
  marketSuggessionCacheStorage,
  goToNextRegion,
}: {
  region: { [key: string]: string };
  currentIndex: number;
  setUpdatedCsv: React.Dispatch<React.SetStateAction<{ [key: string]: any }>>;
  marketSuggessionCacheStorage: any;
  goToNextRegion: () => void;
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [suggessions, setSuggessions] = useState<any>(null);
  const [currentSuggessionIndex, setCurrentSuggessionIndex] = useState<number>(0);
  const [selectedDistrict, setSelectedDistrict] = useState<string>('');
  const [selectedCity, setSelectedCity] = useState<string>('');
  const [selectedCountryCode, setSelectedCountryCode] = useState<string>('');
  const [selectedCreatedBy, setSelectedCreatedBy] = useState<string>('');
  const [mapCopy, setMapCopy] = useState<any>(null);
  const [mapsCopy, setMapsCopy] = useState<any>(null);
  const [mapCenter, setMapCenter] = useState<any>({ lat: 12.1342, lng: -1.2345 });
  const [polygonOnMap, setPolygonOnMap] = useState<any>(null);
  const [isTailoredRegionOpen, setIsTailoredRegionOpen] = useState<boolean>(false);
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState<boolean>(false);
  const [createdTailoredRegionMarket, setCreatedTailoredRegionMarket] = useState<any>(null);

  useEffect(() => {
    console.log('==>>> ', createdTailoredRegionMarket);
    createdTailoredRegionMarket &&
      setSuggessions(prevSuggessions => [
        {
          id: String(createdTailoredRegionMarket.id),
          district: createdTailoredRegionMarket.district,
          city: createdTailoredRegionMarket.city,
          country: createdTailoredRegionMarket.country,
          countryCode: createdTailoredRegionMarket.countryCode,
          createdBy: 'You',
          polygon: processPolygonString(createdTailoredRegionMarket.polygon),
          multiPolygon: null,
        },
        ...(prevSuggessions ? prevSuggessions : []),
      ]);
  }, [createdTailoredRegionMarket]);

  const getMarketSuggessions = async region => {
    setIsLoading(true);
    setCurrentSuggessionIndex(0);

    const URL =
      'https://ho6l549x9i.execute-api.us-east-2.amazonaws.com/default/getMarketSuggessionsFromDistrictName';
    const suggessions = await callApi(
      URL,
      {
        queryParams: {
          district: region.city,
          countryCode: region.countryCode,
        },
      },
      true
    );

    console.log(':', suggessions);

    if (typeof suggessions !== 'object' || suggessions.error) {
      setSuggessions(null);
      setIsLoading(false);
      return;
    }

    setSuggessions(suggessions);
    setCurrentSuggessionIndex(0);
    setIsLoading(false);
  };

  useEffect(() => {
    getMarketSuggessions(region);
  }, [region]);

  useEffect(() => {
    polygonOnMap && polygonOnMap.setMap(null);

    if (suggessions) {
      const currentSelectedSuggession = suggessions[currentSuggessionIndex];
      setSelectedDistrict(currentSelectedSuggession.district);
      setSelectedCity(currentSelectedSuggession.city);
      setSelectedCountryCode(currentSelectedSuggession.countryCode);
      setSelectedCreatedBy(
        currentSelectedSuggession.createdBy ? currentSelectedSuggession.createdBy : ''
      );

      const currentPolygon = drawPolygon(
        currentSelectedSuggession.polygon,
        currentSelectedSuggession.multiPolygon
      );
      setPolygonOnMap(currentPolygon);
    } else {
      setSelectedDistrict('');
      setSelectedCity('');
      setSelectedCountryCode('');
      setSelectedCreatedBy('');
    }
  }, [suggessions, currentSuggessionIndex]);

  const handleApiLoaded = ({ map, maps }) => {
    setMapCopy(map);
    setMapsCopy(maps);

    // processPolygon();
  };

  const setPolygon = (
    map,
    maps,
    paths: Coordinates[][],
    strokeColor: string,
    fillColor: string
  ) => {
    const polygon = new maps.Polygon({
      paths: paths,
      strokeColor: strokeColor,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: fillColor,
      fillOpacity: 0.12,
    });
    polygon.setMap(map);

    return polygon;
  };

  const processPolygonString = (polygonString: string) => {
    if (polygonString.includes('POLYGON')) {
      polygonString = polygonString.replace(/POLYGON/g, 'POLYGON ');
    } else {
      polygonString = polygonString.replace(/MULTIPOLYGON/g, 'MULTIPOLYGON ');
    }
    if (!polygonString.includes(', ')) {
      polygonString = polygonString.replace(/,/g, ', ');
    }
    return polygonString;
  };

  const drawPolygon = (polygon, multiPolygon) => {
    if (mapCopy && mapsCopy) {
      const polygonPaths: Coordinates[][] = getPolygonPaths(
        polygon ? processPolygonString(polygon) : polygon,
        multiPolygon ? processPolygonString(multiPolygon) : multiPolygon
      );

      // Create a new LatLngBounds object
      const bounds = new mapsCopy.LatLngBounds();

      // Iterate through all polygons to extend the bounds
      polygonPaths.forEach(path => {
        path.forEach(data => {
          const { lat, lng } = data;
          bounds.extend(new mapsCopy.LatLng(lat, lng));
        });
      });

      const newCenter = bounds.getCenter();
      setMapCenter({ lat: newCenter.lat(), lng: newCenter.lng() });

      // Auto-adjust the map to fit the polygon bounds
      mapCopy.fitBounds(bounds);

      const polygonOnMap = setPolygon(mapCopy, mapsCopy, polygonPaths, '#f00', '#f00');
      return polygonOnMap;
    }
    return null;
  };

  const saveProgress = () => {
    setUpdatedCsv(prevCsv => {
      const newCsv = { ...prevCsv };
      newCsv[currentIndex] = {
        district: selectedDistrict,
        city: selectedCity,
        countryCode: selectedCountryCode,
        id: suggessions[currentSuggessionIndex].id,
      };
      localStorage.setItem('updated-market-csv', JSON.stringify(newCsv));
      return newCsv;
    });
  };

  const setMarketVerifiedInTable = market_id => {
    if (!market_id) return;

    const URL =
      'https://6kak9cu475.execute-api.us-east-2.amazonaws.com/default/setManuallyVerifiedMarket';

    console.log('=== API CALLED WITH ID: ', market_id);

    callApi(
      URL,
      {
        queryParams: {
          marketId: String(market_id),
        },
      },
      true
    );
  };

  return (
    <>
      <Grid container sx={{ padding: '20px' }}>
        {isLoading && <LoaderScreen />}
        <Grid container>
          <Grid container item xs={12}>
            <Grid item xs={12} sx={{ marginTop: '10px', marginBottom: '10px' }}>
              <Typography variant="body1">Selected Market:</Typography>
            </Grid>
            <Grid container item xs={12} spacing={2}>
              <Grid item xs={4}>
                <TextField
                  id="district"
                  label="district"
                  variant="outlined"
                  value={selectedDistrict}
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  id="city"
                  label="City"
                  variant="outlined"
                  value={selectedCity}
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={1}>
                <TextField
                  id="country_code"
                  label="Country Code"
                  variant="outlined"
                  value={selectedCountryCode}
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  id="created_by"
                  label="Created By"
                  variant="outlined"
                  value={selectedCreatedBy}
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </Grid>
            </Grid>
            <Grid container item xs={12} spacing={2} sx={{ marginTop: '10px' }}>
              <Grid item xs={3}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => setIsTailoredRegionOpen(true)}
                >
                  Create Market
                </Button>
              </Grid>
              <Grid item xs={3}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    setIsConfirmationBoxOpen(true);
                  }}
                >
                  Confirm Market
                </Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid item container spacing={2} xs={12} sx={{ padding: '20px' }}>
            <Grid item xs={9}>
              <Paper
                id="map"
                sx={{
                  position: 'relative',
                  top: '0',
                  left: '0',
                  height: 580,
                  width: '100%',
                }}
              >
                <GoogleMapReact
                  bootstrapURLKeys={{
                    key: 'AIzaSyDUnmEGqix9gziZQjtCQFJ7mCTSDV9yPDk',
                    libraries: ['drawing', 'places', 'visualization'],
                    id: 'dashboard2',
                  }}
                  style={{ height: '100%', width: '100%' }}
                  center={mapCenter}
                  options={map => mapOptions(map, false)}
                  zoom={8}
                  resetBoundsOnResize={true}
                  yesIWantToUseGoogleMapApiInternals
                  onGoogleApiLoaded={handleApiLoaded}
                ></GoogleMapReact>
              </Paper>
            </Grid>
            <Grid item xs={3}>
              <List
                component="nav"
                sx={{ boxShadow: '0 2px 20px -10px #0003', height: '510px', overflow: 'auto' }}
              >
                {suggessions &&
                  suggessions.map((market, index) => {
                    return (
                      <ListItemButton
                        key={index}
                        selected={currentSuggessionIndex === index}
                        onClick={event => setCurrentSuggessionIndex(index)}
                      >
                        <ListItemText primary={market.district} />
                        <ListItemIcon sx={{ minWidth: 0 }}>
                          <CloseIcon />
                        </ListItemIcon>
                      </ListItemButton>
                    );
                  })}
              </List>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {isTailoredRegionOpen && (
        <OnboardingModal
          getTokenThunk={getTokenThunk}
          setIsTailoredRegionOpen={setIsTailoredRegionOpen}
          tailoredRegionMarkers={[]}
          getTailoredRegionMarkers={getTailoredRegionMarkers}
          handleOnSampleClick={() => {}}
          isAdminMapVisualizerTool={true}
          setAdminCreatedTailoredRegionMarket={setCreatedTailoredRegionMarket}
        />
      )}

      {isConfirmationBoxOpen && (
        <Dialog
          open={true}
          // onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Do you wanna select this market as verified?
          </DialogTitle>
          <DialogActions>
            <Button
              onClick={() => {
                setIsConfirmationBoxOpen(false);
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                setIsConfirmationBoxOpen(false);
                saveProgress();
                setMarketVerifiedInTable(suggessions[currentSuggessionIndex].id);
                goToNextRegion();
              }}
              autoFocus
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default IndividualMarketView;
